import React from 'react';
import { VideoExplainerPage } from './pageTypes/VideoExplainerPage';
import SingleQuestionPage from './pageTypes/SingleQuestionPage/SingleQuestionPage';
import DetailsPage from './pageTypes/DetailsPage';
// TODO - this function is just using type casting to force the type of 'item'.  The generated
// types by Kentico don't provide an out-of-the-box means of mapping a type to a key. There is
// certainly a way to do this with more adavanced typescript (likely using "discriminated unions"),
// but I can't figure it out right now.  Once we do, it would replace this big nasty switch statment
// below.
export function PageRenderer({ basePage, customPage, }) {
    switch (basePage.system.type) {
        case 'video_explainer_page':
            return (React.createElement(VideoExplainerPage, { basePage: basePage, customPage: customPage }));
        case 'single_question_page':
            return React.createElement(SingleQuestionPage, { page: basePage });
        case 'details_page':
            return React.createElement(DetailsPage, { page: basePage });
        default:
            throw `codename "${basePage.system.type}" of Kentico Content Model does not match up to a known Page component.`;
    }
}
//# sourceMappingURL=PageRenderer.js.map